/* global jobIds, jobImpressionsURL -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import 'slick-carousel';
import LicensesSearch from '@common/licenses';
import SpecialtiesSearch from '@common/specialties';

$(document).ready(function () {
    const $specialtySort = $('input[name="specialty-sort"]');
    const $popularLocationsCarousel = $('.popular-locations');
    const $recentJobsCarousel = $('.recent-jobs-carousel');
    const $showMobileFiltersBtn = $('button#show-mobile-filters');
    const $mobileFilters = $('.card.filter.mobile');
    const $viewMoreSpecialties = $('#view-more-specialties');

    function addJobImpressions(jobIdArr) {
        if (!jobIdArr || jobIdArr.length === 0) {
            return;
        }
        return $.post(jobImpressionsURL, { jobIds: jobIdArr });
    }

    addJobImpressions(jobIds);

    /**
     * Toggles a class on the main container to show mobile filters.
     */
    function toggleMobileFilters() {
        $('main > .container').toggleClass('show-mobile-filters');
        $('body > footer').toggleClass('d-none');
    }

    function submitMobileFilterForm() {
        $mobileFilters.find('#browse-jobs-filter-form').submit();
    }

    $mobileFilters.on('click', '.card-footer button', submitMobileFilterForm);

    $showMobileFiltersBtn.on('click', toggleMobileFilters);
    $mobileFilters.on('click', '.mdi-close', toggleMobileFilters);

    $popularLocationsCarousel.slick({
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 500,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.popular-locations-prev').on('click', () => {
        $popularLocationsCarousel.slick('slickPrev');
    });

    $('.popular-locations-next').on('click', () => {
        $popularLocationsCarousel.slick('slickNext');
    });

    $recentJobsCarousel.slick({
        arrows: false,
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        lazyLoad: 'ondemand',
        slidesToScroll: 2,
        slidesToShow: 2,
        speed: 500,
        rows: 2,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    autoplaySpeed: 3000,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    rows: 2,
                    centerMode: true,
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    autoplaySpeed: 3000,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    rows: 1,
                    centerMode: true,
                },
            },
        ],
    });

    $('.recent-jobs-prev').on('click', () => {
        $recentJobsCarousel.slick('slickPrev');
    });

    $('.recent-jobs-next').on('click', () => {
        $recentJobsCarousel.slick('slickNext');
    });

    function toggleViewMoreSpecialties(initVal) {
        let value;

        if (!initVal) {
            value = $specialtySort.val();
        } else {
            value = initVal;
        }

        if (value !== 'alphabetical' && value !== 'freight') {
            // Hide view more;
            $viewMoreSpecialties.hide();
            return;
        }

        $viewMoreSpecialties.show();
    }

    if ($specialtySort) {
        toggleViewMoreSpecialties();

        $viewMoreSpecialties.on('click', function() {
            const $panes = $('#toggle-panes');
            const allShown = $panes.hasClass('show-all');

            $(this).text(allShown ? 'View More' : 'View Less');

            $panes.toggleClass('show-all');
        });

        // Specialty sort toggle does not exist on every brand.
        $specialtySort.on('change', function () {
            const value = $(this).val();
            const $panes = $('#toggle-panes');
            $panes.children().hide();
            $panes.find(`.toggle-${value}`).show();

            toggleViewMoreSpecialties(value);
        });
    }

    LicensesSearch.init();
    SpecialtiesSearch.init();
});
